import { ORM } from 'redux-orm'

import Appearance from "contexts/Appearance/model"
import Arena from "contexts/Arena/model"
import Brand from 'contexts/Brand/model'
import Championship from 'contexts/Championship/model'
import Contract from "contexts/Contract/model"
import Draft from 'contexts/Draft/model'
import Faction from 'contexts/Faction/model'
import Feud from 'contexts/Feud/model'
import Game from 'contexts/Game/model'
import Injury from "contexts/Injury/model"
import Ledger from "contexts/Ledger/model"
import Mail from "contexts/Mail/model"
import Notification from "contexts/Notification/model"
import Production from "contexts/Production/model"
import Reign from "contexts/Reign/model"
import Rumble from "contexts/Rumble/model"
import Segment from "contexts/Segment/model"
import Show from "contexts/Show/model"
import Tournament from "contexts/Tournament/model"
import Wrestler from "contexts/Wrestler/model"

// NEW RULE: DATES CAN ONLY GO FORWARD
// NEW RULE: ON DATE CHANGE WE

// NOTIFICATION
// id, name, desc, completed
// when: Action triggered
// monitor actions coming into the store and trigger notification on certain scenarios
// eg an injury getting added, add a notification with a generic action message about it
// notification button on header with menu that opens a list of notifications

// RUMBLE
// Port of FS9

// CONTRACT
// id, wrestlerId, brandId, total, used, remaining, startDate, endDate
// when: Date change
// NOPE: SUM number of appearances for brand since the start of contract date and update appearance count remaining on Wrestler
// think about this

// INJURY
// id, wrestlerId, startDate, endDate, type
// when: DATE CHANGE
// remove damage daily with a decay rate based on stamina, points and number of wins+losses

// MAIL
// When: on date change,
// check for random events like find loser and send message,
// find winner and send message, messages can be sent to the gm of the brand they competed on
// only allow the calendar to go forward
// only 2 messages per day pre check so it couldnt be abused
// give a modifier function which can do anything to the session, e.g. reset injured
// lets say a wrestler random gets a damage reduction for a recent win

Appearance.modelName = 'Appearance'
Arena.modelName = 'Arena'
Brand.modelName = 'Brand'
Contract.modelName = 'Contract'
Draft.modelName = 'Draft'
Faction.modelName = 'Faction'
Feud.modelName = 'Feud'
Game.modelName = 'Game'
Injury.modelName = 'Injury'
Ledger.modelName = 'Ledger'
Mail.modelName = 'Mail'
Notification.modelName = 'Notification'
Production.modelName = 'Production'
Reign.modelName = 'Reign'
Rumble.modelName = 'Rumble'
Segment.modelName = 'Segment'
Show.modelName = 'Show'
Tournament.modelName = 'Tournament'
Wrestler.modelName = 'Wrestler'

export const orm = new ORM({
  stateSelector: state => state.entitiesv2
})

orm.register(
  Appearance,
  Arena,
  Brand,
  Championship,
  Contract,
  Draft,
  Faction,
  Feud,
  Game,
  Injury,
  Ledger,
  Mail,
  Notification,
  Production,
  Reign,
  Rumble,
  Segment,
  Show,
  Tournament,
  Wrestler,
)
